import { render, staticRenderFns } from "./dev-bind-list.vue?vue&type=template&id=6c5a0be6&"
import script from "./dev-bind-list.vue?vue&type=script&lang=js&"
export * from "./dev-bind-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports